import ListEntitiesItemDescriptionMultipleLines, {
  type ListEntitiesItemDescriptionMultipleLinesProps,
} from "components/ListEntitiesItem/Description/MultipleLines";
import { Maybe } from "types/generated";

import TableCellEmpty from "./CellEmpty";

type TableCellDescriptionProps = {
  description?: Maybe<string>;
} & Pick<ListEntitiesItemDescriptionMultipleLinesProps, "onShowFullDescription">;

/**
 * TODO: adopt showing description in the table cell with new actions flow
 */
const TableCellDescription = ({
  description,
  onShowFullDescription,
}: TableCellDescriptionProps) => {
  if (!description) {
    return <TableCellEmpty />;
  }

  return (
    <ListEntitiesItemDescriptionMultipleLines
      lines={1}
      description={description}
      onShowFullDescription={onShowFullDescription}
      hasChevronLink
    />
  );
};

TableCellDescription.displayName = "DS.Table.CellDescription";

export default TableCellDescription;
